import React from 'react';
import styles from './SearchBar.module.css';
import { ReactComponent as SearchSVG } from '@assets/SVGs/PresenteeismTable/SearchSVG.svg';

interface SearchBarProps {
	placeholder?: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ placeholder = '...', onChange, className }) => {
	return (
		<div className={`${styles.container} ${className || ''}`}>
			<div className={styles.inputWrapper}>
				<span className={styles.icon}>
					<SearchSVG />
				</span>
				<input
					type="text"
					placeholder={placeholder}
					className={styles.input}
					onChange={onChange}
				/>
			</div>
		</div>
	);
};

export default SearchBar;
